
const orderEntries = (state = [], action) => {
    let exist = false
    let entry = [...state].find(x => x.articleType == action.articleType)
    //console.log([...state].find(x => x.articleEntry == action.articleEntry && x.sizeEntry == action.sizeEntry))
    switch (action.type) {
        case 'ADD_ORDER_ENTRY':
            if (entry != null) {
                exist = true
            }
            if (!exist) {
                //no ArticleType found; create new
                return [
                    ...state,
                    {
                        articleType: action.articleType,
                        articleEntries:
                            [{
                                articleEntry: action.articleEntry,
                                articleSysId: action.articleSysId,
                                sizeEntries:
                                    [{
                                        SizeValue: action.sizeEntry,
                                        Amount: action.numberInput,
                                    }],
                                articleImage: action.image
                            }],
                        id: action.id
                    }
                ]
            } else {
                let entryIndex = entry.articleEntries.findIndex(x => x.articleSysId == action.articleSysId)
                if (entryIndex != null && entryIndex != -1) {
                    //no SizeEntry found; add sizeEntry for articleEntry
                    console.log("ArticleEntry: " + entryIndex)
                    let typeIndex = state.findIndex(x => x.articleType == action.articleType);
                    let orderEntries = [...state];
                    let articleEntries = [...orderEntries[typeIndex].articleEntries]

                    let sizeIndex = articleEntries[entryIndex].sizeEntries.findIndex(x => x.SizeValue == action.sizeEntry)
                    if (sizeIndex != null && sizeIndex != -1) {
                        //sizeEntry found, only add to amount
                        let sizeEntries = [...articleEntries[entryIndex].sizeEntries]
                        console.log("SizeIndex: " + sizeIndex)
                        let amount = [...sizeEntries][sizeIndex].Amount
                        console.log("Amount: " + amount)
                        let newAmount = parseInt(amount) + parseInt(action.numberInput)

                        sizeEntries[sizeIndex] =
                        {
                            SizeValue: action.sizeEntry,
                            Amount: newAmount
                        }

                        articleEntries[entryIndex] = {
                            ...articleEntries[entryIndex],
                            sizeEntries: sizeEntries
                        }

                        orderEntries[typeIndex] = {
                            ...orderEntries[typeIndex],
                            articleEntries: articleEntries
                        }

                        return [...orderEntries]
                    }

                    /////
                    let sizeEntries = [...articleEntries[entryIndex].sizeEntries]
                    console.log("SizeEntries :" + sizeEntries)
                    sizeEntries = [
                        ...sizeEntries,
                        {
                            SizeValue: action.sizeEntry,
                            Amount: action.numberInput,
                        }
                    ]

                    articleEntries[entryIndex] = {
                        ...articleEntries[entryIndex],
                        sizeEntries: sizeEntries
                    }

                    orderEntries[typeIndex] = {
                        ...orderEntries[typeIndex],
                        articleEntries: articleEntries
                    }

                    return [...orderEntries]


                } else {
                    //no ArticleEntry found; add ArticleEntry for ArticleType
                    let typeIndex = state.findIndex(x => x.articleType == action.articleType);
                    let orderEntries = [...state];
                    let articleEntries = [...orderEntries[typeIndex].articleEntries]
                    articleEntries = [
                        ...articleEntries,
                        {
                            articleEntry: action.articleEntry,
                            articleSysId: action.articleSysId,
                            sizeEntries:
                                [{
                                    SizeValue: action.sizeEntry,
                                    Amount: action.numberInput,
                                }],
                            articleImage: action.image
                        }
                    ]
                    orderEntries[typeIndex] = {
                        ...orderEntries[typeIndex],
                        articleEntries: articleEntries
                    }

                    return [
                        ...orderEntries
                    ]
                }
            }

        case 'REMOVE_ORDER_ENTRY':
            let removeEntry = [...state].find(x => x.articleType == action.articleType)
            let removeEntryIndex = removeEntry.articleEntries.findIndex(x => x.articleSysId == action.articleSysId)
            console.log(state)
            return {
                ...state,
                //articleEntries: [removeEntry.articleEntries.slice(0, removeEntryIndex), removeEntry.articleEntries.slice(removeEntryIndex+1)]
            }

        case 'RESET_ADD_DELIVERY':
            return state = []

        default:
            return state
    }
}

export default orderEntries